import React from 'react';
import { useParams } from 'react-router-dom';
import LiveSessionInterface from './LiveSessionInterface';

const LiveSessionPage = () => {
  const { sessionId } = useParams();

  return <LiveSessionInterface sessionId={sessionId} isConsultant={false} />;
};

export default LiveSessionPage;
